export default __webpack_public_path__ + "static/media/clothes-6.440bb83d.svg";